import {Resolve, ActivatedRouteSnapshot, RouterStateSnapshot} from "@angular/router";
import {Table} from "../../model/table";
import {Observable} from "rxjs";
import {TableService} from "./table.service";
import {Injectable} from "@angular/core";



@Injectable()
export class TableResolver implements Resolve<Table>{
  private tableKey;

  constructor(
    private tableservice:TableService
  ){}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any>|Promise<any>|any {

      this.tableKey = route.params['id'];


      const table$ = this.tableservice.getTableByKey(this.tableKey)
        .first();


      return table$;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/table/table-resolver.ts